// extracted by mini-css-extract-plugin
module.exports = {"bgRepeat":"Tape-module--bgRepeat--_gmoy"};